import React, { createContext, useReducer, useContext, useState } from 'react';

const initialState = {
    formData: {},
    formResponse: {},
    formStates: {}
};

const FormContext = createContext(initialState);

// Create a reducer to manage state changes
const formReducer = (state, action) => {
    switch (action.type) {
      case 'UPDATE_FORM_DATA':
        return {
          ...state,
          formData: { ...state.formData, ...action.payload },
        };
      case 'RESPONSE_FORM':
        return {
          formResponse: action.payload
        };
      case 'UPDATE_FORM_STATES':
        return {
          ...state,
          formStates: { ...state.formStates, ...action.payload },
        };
      default:
        return state;
    }
};


export const FormProvider = ({ children }) => {

const [state, dispatch] = useReducer(formReducer, initialState);

  const updateFormData = (data) => {
    dispatch({ type: 'UPDATE_FORM_DATA', payload: data });
  };

  const updateFormResponse = (data) => {
    dispatch({ type: 'RESPONSE_FORM', payload: data})
  };

  const updateFormStates = (data) => {
    dispatch({ type: 'UPDATE_FORM_STATES', payload: data });
  };
  
  return (

    <FormContext.Provider value={{ formData: state.formData, formResponse: state.formResponse, updateFormData, updateFormResponse, formStates: state.formStates, updateFormStates,}}>
      {children}
    </FormContext.Provider>

  );
};


export const useFormContext = () => {
    return useContext(FormContext);
};